export default {
  noActiveRecipe: 'V komore {chamber} nie je aktívna žiadna receptúra.',
  noDataSourceConnected: 'V tejto komore chýba pripojenie ku kontroléru ProTherm. Pripojenie je možné nastaviť v správe zariadení.',
  goToNextStep: 'Prejsť na krok {step}',
  goToPreviousStep: 'Vrátiť sa na krok {step}',
  goToNextStepConfirm: 'Prejsť na krok {step}?',
  goToPreviousStepConfirm: 'Vrátiť sa na krok {step}?',
};
